import React, { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import { article } from "../../../../common/article/article";
import ScrollTop from "../../../../common/scrolltop/scrolltop";
import arrow from "../../../../image/blog/list_arrow.png";
import tagImg from "../../../../image/blog/tag.png";
import styles from "./writing.module.css";
import header from "../../../header/header.module.css";

import rocket from "../../../../image/blog/article_rocket.png";
import getGA from "../../../../service/ga.js";
import { Helmet } from "react-helmet-async";
import favicon from "../../../../image/img_mondayoff_s.png";

const Writing = ({ match }) => {
  useEffect(() => {
    getGA();
  }, []);
  const { id } = match.params;
  const [script, setscript] = useState([]);
  const [listScript, setListScript] = useState([]);
  useEffect(() => {
    let findScript = article.find((data) => data.id === Number(id));
    setscript(findScript);
  }, [id]);

  useEffect(() => {
    let findListScript = article.filter((data) => {
      return data.id !== script?.id && data.tag === script?.tag;
    });
    setListScript(findListScript);
  }, [script?.id, script?.tag]);
  const [windowSize, setWindowSize] = useState(window.innerWidth);
  const handleWindowsize = useCallback(() => {
    setWindowSize(window.innerWidth);
  }, []);
  useEffect(() => {
    window.addEventListener("resize", handleWindowsize);
    return () => {
      window.removeEventListener("resize", handleWindowsize);
    };
  });
  useEffect(() => {
    const menulist = document.getElementsByClassName(header.menulist);
    const logoImg = document.getElementsByClassName(header.logo);
    menulist[0].classList.remove(header.active);
    logoImg[0].classList.remove(header.active);
  }, []);
  useEffect(() => {
    const nav = document.getElementsByClassName(header.nav);
    const gameMenu = document.getElementsByClassName(header.gamemenu);
    const gameText = document.getElementsByClassName(header.gametext);
    const publishPage = document.getElementsByClassName(header.publishmenu);
    const publishText = document.getElementsByClassName(header.publishtext);
    const partnershipPage = document.getElementsByClassName(
      header.partnershipmenu
    );
    const partnershipText = document.getElementsByClassName(
      header.partnershiptext
    );
    const articleMenu = document.getElementsByClassName(header.articlemenu);
    const articleText = document.getElementsByClassName(header.articletext);
    if (match.path === `/:tagname/:id`) {
      if (windowSize < 769) {
        nav[0].style.position = "sticky";
        gameMenu[0].style.borderBottom = "";
        gameText[0].style.fontWeight = "";
        publishPage[0].style.borderBottom = "";
        publishText[0].style.fontWeight = "";
        partnershipPage[0].style.borderBottom = "";
        partnershipText[0].style.fontWeight = "";
        articleMenu[0].style.borderBottom = "";
        articleText[0].style.fontWeight = 700;
      } else {
        nav[0].style.position = "sticky";
        gameMenu[0].style.borderBottom = "";
        gameText[0].style.fontWeight = "";
        publishPage[0].style.borderBottom = "";
        publishText[0].style.fontWeight = "";
        partnershipPage[0].style.borderBottom = "";
        partnershipText[0].style.fontWeight = "";
        articleMenu[0].style.borderBottom = "5px solid #ffff";
        articleText[0].style.fontWeight = 700;
      }
    }
  }, [id, match.path, windowSize]);

  const onClick = () => {
    window.scrollTo(0, 0);
  };
  let keywordArr = script?.keyword && script?.keyword.join(", ");
  let scriptTag = script?.tag?.replace(/ /g, "");

  return (
    <>
      <ScrollTop />
      <Helmet>
        <title>MondayOFF - {`${script?.title}`}</title>
        <link rel="icon" href={favicon} data-react-helmet="true" />
        <meta
          name="description"
          content={`${
            script?.context ? script?.context : script?.contents?.firstContents
          }`}
          data-react-helmet="true"
        />
        <meta property="og:type" content="website" data-react-helmet="true" />
        <meta
          property="og:site_name"
          content={`MondayOFF - ${script?.title}`}
          data-react-helmet="true"
        />
        <meta
          property="og:title"
          content={`MondayOFF - ${script?.title}`}
          data-react-helmet="true"
        />
        <meta
          property="og:description"
          content={`${
            script?.context ? script?.context : script?.contents?.firstContents
          }`}
          data-react-helmet="true"
        />
        <meta
          property="og:image"
          content={script?.topImg}
          data-react-helmet="true"
        />
        <meta
          property="og:url"
          content={`https://www.mondayoff.me/${scriptTag}/${script?.id}`}
          data-react-helmet="true"
        />
        <meta
          property="twitter:card"
          content="summary"
          data-react-helmet="true"
        />
        <meta
          property="twitter:title"
          content={`MondayOFF - ${script?.title}`}
          data-react-helmet="true"
        />
        <meta
          property="twitter:url"
          content={`https://www.mondayoff.me/${scriptTag}/${script?.id}`}
          data-react-helmet="true"
        />
        <meta
          property="twitter:image"
          content={script?.topImg}
          data-react-helmet="true"
        />
        <meta
          property="twitter:description"
          content={`${
            script?.context ? script?.context : script?.contents?.firstContents
          }`}
          data-react-helmet="true"
        />
      </Helmet>
      <div className={styles.button} onClick={onClick}>
        <div className={styles.toparrow}>⌃</div>
      </div>
      <div className={styles.container}>
        <div className={styles.topcontainer}>
          <Link to="/blog" className={styles.backpage}>
            <img src={arrow} alt="" />
            <p>List</p>
          </Link>
        </div>
        <div className={styles.scriptcontainer}>
          <div className={styles.tag}>{script?.tag}</div>
          <div className={styles.title}>{script?.title}</div>
          <div className={styles.profile}>
            <img
              src={script?.profileImg}
              alt=""
              className={styles.profileImg}
            />
            <div className={styles.name}>{script?.name}</div>
            <div className={styles.date}>{script?.date}</div>
          </div>

          <div className={styles.contentscontainer}>
            <img src={script?.topImg} alt="" className={styles.contentsImg} />
          </div>
          <div className={styles.contentsblock}>
            <div>
              <div className={styles.topcontents}>
                <p>{script?.context}</p>
              </div>

              <div className={styles.parag}>
                <div className={styles.contentsContainer}>
                  {script?.contents}
                </div>
              </div>

              {keywordArr ? (
                <div className={styles.keyword}>
                  <img src={tagImg} alt="" />
                  <p>{keywordArr}</p>
                </div>
              ) : null}
            </div>
            <div className={styles.listblock}>
              <p>You might also like</p>
              <div className={styles.contentslist}>
                {listScript.map((data) => {
                  let scriptTag = data?.tag?.replace(/ /g, "");
                  return (
                    <Link to={`/${scriptTag}/${data.id}`}>
                      <div>
                        <img
                          src={data?.topImg ? data?.topImg : data.img}
                          alt=""
                          className={styles.listimg}
                        />
                        <div className={styles.listtag}>{data?.tag}</div>
                        <div className={styles.listtitle}>{data?.title}</div>
                      </div>
                    </Link>
                  );
                })}
              </div>
            </div>
          </div>
          <div className={styles.bottomcontainer}>
            <p>Publish with us</p>
            <Link to="/publishingsubmit">
              <div className={styles.subbtn}>Submit your game</div>
            </Link>
            <img src={rocket} alt="rocket" className={styles.rocket} />
            <div className={styles.backcolor}></div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Writing;
